import script from "./GuruPage.vue?vue&type=script&setup=true&lang=js"
export * from "./GuruPage.vue?vue&type=script&setup=true&lang=js"

import "./GuruPage.vue?vue&type=style&index=0&id=b979bc4e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b979bc4e"]])

export default __exports__